import React, { useEffect, useRef, useState } from "react";
import * as Fa from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { AutoComplete } from "primereact/autocomplete";
import { RadioButton } from "primereact/radiobutton";
import { PickList } from "primereact/picklist";
import { InputNumber } from "primereact/inputnumber";
import { fetchData, postData } from "../../../../Services/GlobalService";
import { MultiSelect } from "primereact/multiselect";
import PickListSchem from "./PickListSchem";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import {
  downloadExcel,
  downloadExcelDateFormat,
} from "../../../../Services/GlobalFunction/DownLoadExcel";
import { GetDateFormat } from "../../../../Services/GlobalFunction/GetDateFormat";
import { format } from "date-fns";
import Loader from "../../../../Components/Loader";
import { ProgressSpinner } from "primereact/progressspinner";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Checkbox } from "primereact/checkbox";

const SchemeDiscountDefinition = () => {
  const nav = useNavigate();
  // const op = useRef<OverlayPanel | null>(null);
  const [schemeCode, setSchemeCode] = useState("");
  const [schemeName, setSchemeName] = useState("");
  const [schmstartdt, setSchmstartdt] = useState<Date>();
  const [schmenddt, setSchmenddt] = useState<Date>();
  const [schmUploadType, setSchmUploadType] = useState<any>(null);
  const [schmUploadTypeOption, setSchmUploadTypeOption] = useState([]);
  const [percentagevalue, setPercentagevalue] = useState<any>(0);
  const [activationsts, setActivationsts] = useState("Active");
  const [schmbenefitstats, setSchmbenefitstats] = useState("Include");
  const [promocodeStats, setPromocodeStats] = useState<boolean>(true);
  const [discountType, setDiscountType] = useState({
    name: "Percentage",
    code: "PERCENT",
  });
  const [errorsDist, setErrorsDist] = useState({
    region: false,
    state: false,
    stream: false,
  });

  const [streamType, setStreamType] = useState<any>(null);
  // const [stream,setSchmenddt] = useState("");
  // const [schmenddt,setSchmenddt] = useState("");
  const [region, setRegion] = useState<any>();
  const [sourceDist, setSourceDist] = useState<any>([]);
  const [targetDist, setTargetDist] = useState<any>([]);
  const [sourceProd, setSourceProd] = useState<any>([]);
  const [targetProd, setTargetProd] = useState<any>([]);
  const [uploadedCust, setUploadedCust] = useState<any>([]);
  const [uploadedStream, setUploadedStream] = useState<any>([]);
  const [excelData, setExcelData] = useState<any>([]);
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const [state, setState] = useState<any>();
  const [selectedstate, setSelectedstate] = useState<any>();
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [distLoading, setDistLoading] = useState<boolean>(false);
  const [showErrorbtn, setShowErrorbtn] = useState<boolean>(false);
  const [custSegType, setCustSegType] = useState<any>("All");
  const [probapplic, setProbapplic] = useState<any>("All");
  const [prodSelcen, setProdSelcen] = useState<any>("Picklist");
  const [invAmount, setInvAmount] = useState<any>(0);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const prodfileInputRef = useRef<HTMLInputElement | null>(null);
  const [errorxlsData, setErrorxlsData] = useState<any>([]);
  const [errorxlsProdData, setErrorxlsProdData] = useState<any>([]);
  const [tempprodUpLoading, setTempprodUpLoading] = useState<boolean>(false);
  const [showUpprodloading, setShowUpprodloading] = useState<boolean>(false);
  const [finalSaveLoading, setFinalSaveLoading] = useState<boolean>(false);
  const [showErrorbtnprod, setShowErrorbtnprod] = useState<boolean>(false);

  const [tempLoading, setTempLoading] = useState(false);
  const [tempUpLoading, setTempUpLoading] = useState(false);
  const [showUploading, setShowUploading] = useState(false);
  const [saveBtndisle, setSaveBtndisle] = useState(false);
  const [viewSchmDetls, setViewSchmDetls] = useState(false);
  const [loadingWhl, setLoadingWhl] = useState(false);

  const [selectedSchm, setSelectedSchm] = useState<any>([]);
  const [uploadedProd, setUploadedProd] = useState<any>([]);
  const [excelProdData, setExcelProdData] = useState<any>([]);
  const [selectedSchmDetl, setSelectedSchmDetl] = useState<any>();

  const UserId = localStorage.getItem("UserId")?.toString();
  const discountTypeopt = [
    { name: "Percentage", code: "PERCENT" },
    { name: "Value", code: "VLU" },
  ];
  const streamTypeopt = [
    { name: "B2B", code: "b2b" },
    { name: "B2C", code: "b2c" },
    { name: "INDUSTRIAL", code: "indst" },
    { name: "HD", code: "hd" },
  ];

  const [schmCodeParam] = useSearchParams();
  let schmCode = schmCodeParam.get("schmID");
  // console.log("schmCode", schmCode);
  const CommonURl = "CommonDropdown";
  const Controller = "SchemeFlatDiscount";
  const EndPoint = {
    DropDownList: "DropDownList",
  };
  const SchmEndPoint = {
    SaveFlatDiscCustProdData: "SaveFlatDiscCustProdData",
    ValidationCustData: "ValidationCustData",
    ValidationSegMentData: "ValidationSegMentData",
    GetAllFlatDiscountData: "GetAllFlatDiscountData",
    GetSchemeDetlData: "GetSchemeDetlData",
    UpdateFlatDiscountData: "UpdateFlatDiscountData",
    GetSchemeProdDetlData: "GetSchemeProdDetlData",
    ValidationProductData: "ValidationProductData",
  };

  const parseDDMMYYYY = (dateStr: string): Date => {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day); // month is 0-based
  };
  const isSameDate = (d1: Date, d2: Date): boolean =>
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const isEndDateToday =
    selectedSchm[0]?.END_DATE &&
    isSameDate(parseDDMMYYYY(selectedSchm[0].END_DATE), today);
  const validateForm = () => {
    const newErrors: any = {};

    const schemeCodePattern = /^[a-zA-Z0-9]+$/; // only letters and numbers
    const schemeNamePattern = /^[a-zA-Z0-9\s()\[\]]+$/; // letters, numbers, spaces, ()[]

    if (!schemeCode) {
      newErrors.schemeCode = "Scheme Code is required";
    } else if (schemeCode?.trim()?.length > 15) {
      newErrors.schemeCode = "Scheme Code can't be more than 15";
    } else if (!schemeCodePattern?.test(schemeCode)) {
      newErrors.schemeCode = "Scheme Code can only contain letters and numbers";
    }

    if (!schemeName) {
      newErrors.schemeName = "Scheme Name is required";
    } else if (schemeName?.trim()?.length > 50) {
      newErrors.schemeName = "Scheme Name can't be more than 50";
    } else if (!schemeNamePattern.test(schemeName)) {
      newErrors.schemeName =
        "Scheme Name can only contain letters, numbers, spaces, and brackets ()[]";
    }
    if (!schmstartdt) newErrors.schmstartdt = "Start Date is required";
    if (!schmUploadType) newErrors.schmUploadType = "please select Upload Type";
    if (schmUploadType?.Name == "Segment" && !streamType)
      newErrors.streamType = "please select Stream Type";
    if (!schmenddt) newErrors.schmenddt = "End Date is required";
    if (!discountType) newErrors.discountType = "Discount Type is required";
    if (percentagevalue === null || percentagevalue == 0)
      newErrors.percentagevalue = "Percentage is required";
    if (invAmount === null || invAmount == 0)
      newErrors.invAmount = "Invoice value is required";
    if (schmstartdt && schmenddt && schmenddt <= schmstartdt) {
      newErrors.schmenddt = "End Date must be greater than Start Date";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // console.log(errors, "errors");

  const submitSchmDisc = async () => {
    setSubmitted(true);
    if (viewSchmDetls) {
      let payload = {
        TVP_SCHM_CODE: schemeCode,
        TVP_END_DATE: format(schmenddt ?? new Date(), "dd/MM/yyyy"),
        TVP_IS_INCLUSIVE: schmbenefitstats == "Include" ? "Y" : "N",
        TVP_IS_ACTIVE: activationsts == "Active" ? "Y" : "N",
        TVP_PROMO_INCLUDED: promocodeStats == true ? "Y" : "N",
        TVP_GROUP_ID: probapplic === "Any" ? "1" : null,
        TVP_USER_ID: UserId,
      };
      // console.log(payload, "updatepayload");
      const saveSchmData = await postData(
        Controller,
        `${SchmEndPoint.UpdateFlatDiscountData}`,
        payload
      );
      toast.success(`${saveSchmData?.Message}`);
      nav("/Master/Scheme/SchemeDiscDefAllRec");
    } else {
      if (validateForm()) {
        // setSaveBtndisle(true);
        setSubmitted(true);
        if (prodSelcen == "Picklist" && targetProd.length == 0) {
          toast.warn("Please select atleast one product");
          setSaveBtndisle(false);
          return;
        } else if (uploadedProd.length == 0 && prodSelcen == "Upload") {
          toast.warn("Please upload atleast one product");
          setSaveBtndisle(false);
          return;
        }
        if (schmUploadType?.Name == "Segment") {
          if (custSegType === "Specific" && uploadedStream?.length == 0) {
            toast.warn("Please upload the segment specific file");
            setSaveBtndisle(false);
            return;
          }
        } else {
          if (targetDist?.length == 0) {
            toast.warn("Please select distributor");
            setSaveBtndisle(false);
            return;
          }
          if (custSegType === "Specific" && uploadedCust?.length == 0) {
            toast.warn("Please upload the customer specific file");
            setSaveBtndisle(false);
            return;
          }
        }
        setLoadingWhl(true);
        let prodHeader = {
          SCHM_CODE: schemeCode,
          SCHM_NAME: schemeName,
          START_DATE: format(schmstartdt ?? "", "yyyy-MM-dd"),
          END_DATE: format(schmenddt ?? "", "yyyy-MM-dd"),
          DISC_TYPE: null,
          DISC_VAL: null,
          THRESHOLD_VALUE: invAmount.toString(),
          SCHM_LEVEL_NO: schmUploadType?.ID.toString(),
          REF_SCHM_LEVEL_ID: "",
          IS_INCLUSIVE: schmbenefitstats == "Include" ? "Y" : "N",
          IS_ACTIVE: activationsts == "Active" ? "Y" : "N",
          ENTER_BY: UserId,
          PROMO_INCLUDED: promocodeStats == true ? "Y" : "N",
        };
        let prodDetls = {
          SCHM_CODE: schemeCode,
          PROD_ID: "",
          ROLE_TYPE: "B",
          REQ_QTY: "1",
          DISCOUNT_TYPE: "PERCENT",
          DISCOUNT_VAL: percentagevalue.toString(),
          GROUP_ID: probapplic === "Any" ? "1" : null,
        };
        let schemeCustomerPayload = [];
        const schemeCustomerPayloaddetls =
          prodSelcen == "Picklist"
            ? targetProd.map((prods: any) => ({
                ...prodDetls,
                PROD_ID: prods.Product_ID,
              }))
            : uploadedProd.map((prods: any) => ({
                ...prodDetls,
                PROD_ID: prods.Product_ID,
              }));
        if (custSegType === "Specific") {
          if (schmUploadType?.Name == "Segment") {
            schemeCustomerPayload = uploadedStream?.map((segment: any) => ({
              ...prodHeader,
              REF_SCHM_LEVEL_ID: segment["Segment ID"],
            }));
          } else {
            schemeCustomerPayload = uploadedCust?.map((customer: any) => ({
              ...prodHeader,
              REF_SCHM_LEVEL_ID: customer["Customer ID"],
            }));
          }
        } else {
          if (schmUploadType?.Name == "Segment") {
            let streamUrl = `UserId=${UserId}&PVCtype=Scheme_Segment&PVCPAYLOAD=${JSON.stringify(
              {
                Stream: streamType.name,
              }
            )}`;
            const uploadTyperesdd = await fetchData(
              CommonURl,
              `${EndPoint.DropDownList}`,
              streamUrl
            );
            // console.log(uploadTyperesdd.Data);
            let result = uploadTyperesdd.Data;
            schemeCustomerPayload = result?.map((segment: any) => ({
              ...prodHeader,
              REF_SCHM_LEVEL_ID: segment["Segment ID"],
            }));
          }
        }
        let commasepdist = targetDist
          .map((item: any) => item.Distributor_Code)
          .join(",");
        let prodHeaderforcustAll = {
          SCHM_CODE: schemeCode,
          SCHM_NAME: schemeName,
          START_DATE: format(schmstartdt ?? "", "yyyy-MM-dd"),
          END_DATE: format(schmenddt ?? "", "yyyy-MM-dd"),
          DISC_TYPE: null,
          DISC_VAL: null,
          THRESHOLD_VALUE: invAmount.toString(),
          SCHM_LEVEL_NO: schmUploadType?.ID.toString(),
          REF_SCHM_LEVEL_ID: null,
          IS_INCLUSIVE: schmbenefitstats == "Include" ? "Y" : "N",
          IS_ACTIVE: activationsts == "Active" ? "Y" : "N",
          ENTER_BY: UserId,
          PROMO_INCLUDED: promocodeStats == true ? "Y" : "N",
        };
        let finaljson = {
          UPLOAD_PRODUCT_TYPE_DATA: schemeCustomerPayloaddetls,
          UPLOAD_CUST_TYPE_DATA:
            schmUploadType?.Name == "Customer" && custSegType === "All"
              ? [prodHeaderforcustAll]
              : schemeCustomerPayload,
          dbcode:
            schmUploadType?.Name == "Customer" && custSegType === "All"
              ? commasepdist
              : null,
          isallcustomer:
            schmUploadType?.Name == "Customer" && custSegType === "All"
              ? "Y"
              : null,
        };
        console.log(finaljson, "finaljson");
        // return;
        try {
          setFinalSaveLoading(true);
          const saveSchmData = await postData(
            Controller,
            `${SchmEndPoint.SaveFlatDiscCustProdData}`,
            finaljson
          );
          toast.success(`${saveSchmData?.Message}`);
          nav("/Master/Scheme/SchemeDiscDefAllRec");
        } catch (error: any) {
          toast.error(`${error.response.data.Message}`);
          setSaveBtndisle(false);
        } finally {
          setFinalSaveLoading(false);
          setLoadingWhl(false);
        }
      }
    }
  };
  let convDDMMYYtoMMDDYY = (data: string) => {
    let [day, mon, yr] = data.toString().split("/");
    return `${mon}/${day}/${yr}`;
  };
  useEffect(() => {
    let getUploadType = async () => {
      try {
        const uploadTyperes = await fetchData(
          CommonURl,
          `${EndPoint.DropDownList}`,
          `UserId=${UserId}&PVCtype=Scheme_Level`
        );
        setSchmUploadTypeOption(uploadTyperes.Data);
      } catch (error) {
        console.log(error);
      }
    };
    let chckviewdets = async (shcode: any) => {
      setLoadingWhl(true);
      try {
        const schmviewdetlres = await fetchData(
          Controller,
          `${SchmEndPoint.GetSchemeDetlData}`,
          `SCHM_CODE=${shcode}`
        );
        setSelectedSchmDetl(schmviewdetlres.Data);
        const schmviewres = await fetchData(
          Controller,
          `${SchmEndPoint.GetAllFlatDiscountData}`,
          `SCHEME_CODE=${shcode}`
        );

        setSchemeCode(schmviewres.Data[0].SCHM_CODE);
        setSchemeName(schmviewres.Data[0].SCHM_NAME);
        setSchmstartdt(
          new Date(convDDMMYYtoMMDDYY(schmviewres.Data[0].START_DATE))
        );
        setSchmenddt(
          new Date(convDDMMYYtoMMDDYY(schmviewres.Data[0].END_DATE))
        );
        let viewdistyp = discountTypeopt.filter(
          (item: any) => item.code == schmviewres.Data[0].DISCOUNT_TYPE
        )[0];
        setDiscountType(viewdistyp);
        setPercentagevalue(Number(schmviewres.Data[0].DISCOUNT_VAL));
        setActivationsts(
          schmviewres.Data[0].IS_ACTIVE == "Active" ? "Active" : "Inactive"
        );
        setSchmbenefitstats(
          schmviewres.Data[0].IS_INCLUSIVE == "Y" ? "Include" : "Exclude"
        );
        setPromocodeStats(
          schmviewres.Data[0].PROMO_INCLUDED == "Y" ? true : false
        );
        setInvAmount(Number(schmviewres.Data[0].THRESHOLD_VALUE));
        setProbapplic(schmviewres?.Data[0]?.GROUP_ID == null ? "All" : "Any");
        setSelectedSchm(schmviewres.Data);
        populateProduct(
          schmviewres.Data[0].PROMO_INCLUDED == "Y" ? true : false
        );
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingWhl(false);
      }
    };

    if (schmCode === "null") {
      setViewSchmDetls(false);
      populateProduct(true);
    } else {
      setViewSchmDetls(true);
      chckviewdets(schmCode);
    }
    getUploadType();
  }, []);

  useEffect(() => {
    let getDiffDistType = async () => {
      try {
        const uploadTyperes = await fetchData(
          CommonURl,
          `${EndPoint.DropDownList}`,
          `UserId=${UserId}&PVCtype=Scheme_Region`
        );
        setRegion(uploadTyperes.Data);
      } catch (error) {
        console.log(error);
      }
    };
    if (schmUploadType?.Name == "Customer") {
      getDiffDistType();
    }
  }, [schmUploadType]);

  useEffect(() => {
    if (selectedSchm?.length && schmUploadTypeOption.length) {
      const selectedOption = schmUploadTypeOption.find(
        (opt: any) => opt?.ID === String(selectedSchm[0]?.SCHEME_LEVEL_NO)
      );

      if (selectedOption) {
        setSchmUploadType(selectedOption); // SAME reference ✔
      }
    }
  }, [selectedSchm, schmUploadTypeOption]);

  const handleRegion = (e: any) => {
    const selectedRegions = e.value;
    setSelectedRegion(e.value);
    const selectedregionValus = selectedRegions
      .map((item: any) => `${item.Region_ID}`)
      .join(",");
    stateCallfun(selectedregionValus === "" ? "All" : selectedregionValus);
  };

  let stateCallfun = async (region: any) => {
    try {
      const uploadTyperes = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        `UserId=${UserId}&PVCtype=Scheme_State&PVCPAYLOAD=${JSON.stringify({
          Region: region,
        })}`
      );
      setState(uploadTyperes.Data);
    } catch (error) {
      console.log(error);
    }
  };

  const itemTemplatePanelDist = (item: any) => {
    return (
      <span>
        {item.Distributor_Code} ({item.Distributor_Name})
      </span>
    );
  };
  const itemTemplatePanelProd = (item: any) => {
    return (
      <span>
        {item.Product_ID} ({item.Product_Description})
      </span>
    );
  };

  const populateDistlst = () => {
    const newErrors = {
      region: selectedRegion.length === 0,
      state: selectedstate.length === 0,
      stream: !streamType,
    };

    setErrorsDist(newErrors);

    if (Object.values(newErrors).includes(true)) {
      return;
    } else {
      if (schmUploadType?.Name == "Customer") {
        setTargetDist([]);
        setCustSegType("All");
        const selectedstateValus = selectedstate
          .map((item: any) => `${item.State_ID}`)
          .join(",");
        console.log(selectedRegion,"selectedRegion");
        const selectedRegionValues = selectedRegion
          .map((item: any) => `${item.Region_ID}`)
          .join(",");
        getAllDistributorList(selectedstateValus, streamType?.name, selectedRegionValues);
      }
    }
  };

  let getAllDistributorList = async (statelst: any, segmentlst: any, regionlst: any) => {
    try {
      setDistLoading(true);
      const uploadTyperes = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        `UserId=${UserId}&PVCtype=Scheme_Distributor&PVCPAYLOAD=${JSON.stringify(
          { State: statelst, Stream: segmentlst, Region: regionlst, UserId : UserId }
        )}`
      );
      if (uploadTyperes?.Data?.length == 0 || uploadTyperes?.Data == null) {
        toast.warn("No distributor found.");
      }
      setSourceDist(uploadTyperes.Data);
    } catch (error) {
      console.log(error);
    } finally {
      setDistLoading(false);
    }
  };

  let populateProduct = async (e: boolean) => {
    try {
      console.log(e, "eeeeeeeeeee");
      const prodres = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        `UserId=${UserId}&PVCtype=Scheme_Product&PVCPAYLOAD=${JSON.stringify({
          Isbase: e ? "Y" : "N",
        })}`
      );
      setSourceProd(prodres.Data);
      if (schmCode !== "null") {
        const schmviewproddetlres = await fetchData(
          Controller,
          `${SchmEndPoint.GetSchemeProdDetlData}`,
          `SCHM_CODE=${schmCode}`
        );
        const defaultCodeSet: any = new Set(
          schmviewproddetlres.Data.map((d: any) => d.PROD_ID)
        );
        console.log("defaultCodeSet", defaultCodeSet);
        if (!prodres.Data?.length || defaultCodeSet?.size === 0) return;
        const target: any = [];
        const source: any = [];
        prodres.Data.forEach((prod: any) => {
          if (defaultCodeSet.has(prod.Product_ID)) {
            target.push(prod); // default selected
          } else {
            source.push(prod);
          }
        });
        setSourceProd(source);
        setTargetProd(target);
        console.log(source, target, "prod");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const downloadSavedData = async () => {
    let fileName = `${schmUploadType?.Name}_Saved_Data.xlsx`;
    downloadExcelDateFormat(selectedSchmDetl, fileName);
  };
  let downloadTeampltprod = async () => {
    let fileName = `Template_Product${promocodeStats ? "_Promo" : ""}.xlsx`;
    downloadExcelDateFormat(sourceProd, fileName);
  };
  let downloadTeamplt = async () => {
    if (schmUploadType?.Name == "Customer") {
      if (targetDist?.length == 0) {
        toast.warn("Please select atleast one distributor.");
        return;
      }
    } else {
      if (streamType == null) {
        toast.warn("Please select stream.");
        return;
      }
    }

    let listDist = targetDist
      .map((item: any) => item.Distributor_Code)
      .join(",");
    try {
      setTempLoading(true);
      let custUrl = `UserId=${UserId}&PVCtype=Scheme_Customer&PVCPAYLOAD=${JSON.stringify(
        {
          Distributor: listDist,
        }
      )}`;
      let streamUrl = `UserId=${UserId}&PVCtype=Scheme_Segment&PVCPAYLOAD=${JSON.stringify(
        {
          Stream: streamType.name,
        }
      )}`;
      const uploadTyperes = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        schmUploadType?.Name == "Customer" ? custUrl : streamUrl
      );
      let fileName = `Template_${schmUploadType?.Name}.xlsx`;
      downloadExcelDateFormat(uploadTyperes.Data, fileName);
    } catch (error) {
      console.log(error);
    } finally {
      setTempLoading(false);
    }
  };

  let handleFileUploadXL = (event: React.ChangeEvent<HTMLInputElement>) => {
    setExcelData([]);
    // setUploadedCust([]);
    // setUploadedStream([]);
    const file = event?.target?.files?.[0];
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!file) return;
    if (file && !fileTypes.includes(file.type)) {
      toast.warn("Please specify a valid file. Can upload only Excel file");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        defval: "",
        blankrows: false,
      });

      const filteredData = jsonData.filter((row) =>
        Object.values(row).some((value) => value !== "")
      );

      if (!filteredData.length) {
        toast.warn("The Excel file has no valid data.");
        return;
      }

      const expectedHeaders =
        schmUploadType?.Name == "Customer"
          ? ["Customer Code", "Customer Name", "Distributor Code"]
          : ["Segment Code", "Segment Name"];

      const actualHeaders = Object.keys(filteredData[0]).map((h) => h.trim());

      const missingHeaders = expectedHeaders.filter(
        (header) => !actualHeaders.includes(header)
      );

      if (missingHeaders.length > 0) {
        toast.warn(`Missing required columns: ${missingHeaders.join(", ")}`);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }

      setExcelData(filteredData);
    };

    reader.readAsArrayBuffer(file);
  };
  let handleFileProdup = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files?.[0];
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!file) return;
    if (file && !fileTypes.includes(file.type)) {
      toast.warn("Please specify a valid file. Can upload only Excel file");
      if (prodfileInputRef.current) {
        prodfileInputRef.current.value = "";
      }
      return;
    }
    setShowErrorbtnprod(false);

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        defval: "",
        blankrows: false,
      });

      const filteredData = jsonData.filter((row) =>
        Object.values(row).some((value) => value !== "")
      );

      if (!filteredData.length) {
        toast.warn("The Excel file has no valid data.");
        return;
      }

      const expectedHeaders = ["Product_ID", "Product_Description"];

      const actualHeaders = Object.keys(filteredData[0]).map((h) => h.trim());

      const missingHeaders = expectedHeaders.filter(
        (header) => !actualHeaders.includes(header)
      );

      if (missingHeaders.length > 0) {
        toast.warn(`Missing required columns: ${missingHeaders.join(", ")}`);
        if (prodfileInputRef.current) {
          prodfileInputRef.current.value = "";
        }
        return;
      }

      setExcelProdData(filteredData);
    };

    reader.readAsArrayBuffer(file);
  };

  let handleValidateCustSegXL = async () => {
    setShowErrorbtn(false);
    setTempUpLoading(true);
    setShowUploading(false);
    setUploadedCust([]);
    setUploadedStream([]);

    const timer = setTimeout(() => {
      setShowUploading(true);
    }, 1000);

    try {
      let excelValidation = [];

      if (schmUploadType?.Name == "Customer") {
        excelValidation = excelData.map((item: any) => ({
          distributor_code: item["Distributor Code"],
          cust_code: item["Customer Code"],
          cust_name: item["Customer Name"],
        }));
      } else {
        excelValidation = excelData.map((item: any) => ({
          segmenT_CODE: item["Segment Code"],
          segmenT_DESC: item["Segment Name"],
        }));
      }
      let custValidPyld =
        schmUploadType?.Name == "Customer"
          ? { cusT_VALID_TYPE_DATA: excelValidation }
          : { seG_VALID_TYPE_DATA: excelValidation };
      const validationCustSegRes = await postData(
        Controller,
        `${
          schmUploadType?.Name == "Customer"
            ? SchmEndPoint.ValidationCustData
            : SchmEndPoint.ValidationSegMentData
        }`,
        custValidPyld
      );
      if (validationCustSegRes?.Message === "Warning") {
        toast.warn("There are errors in file upload.");
        setErrorxlsData(validationCustSegRes.Data);
        setShowErrorbtn(true);
      } else {
        toast.success("Data uploaded succesfully");
        if (schmUploadType?.Name == "Customer") {
          setUploadedCust(validationCustSegRes.Data);
        } else {
          setUploadedStream(validationCustSegRes.Data);
        }
      }
    } catch (e: any) {
      toast.error(`${e.response.data.Message}`);
    } finally {
      clearTimeout(timer);
      setTempUpLoading(false);
      setShowUploading(false);
    }
  };
  let handleValidateProdXL = async () => {
    setTargetProd([]);
    setShowErrorbtnprod(false);
    setTempprodUpLoading(true);
    setShowUpprodloading(false);

    const timer = setTimeout(() => {
      setShowUploading(true);
    }, 1000);

    try {
      let prodValid = excelProdData.map((item: any) => ({
        producT_ID: item.Product_ID,
        producT_DESCRIPTION: item.Product_Description,
      }));

      let payloadprod = {
        proD_VALID_TYPE_DATA: prodValid,
        iSbase: promocodeStats ? "Y" : "N",
      };

      // console.log(payloadprod, "payloadprod");

      const validationProdRes = await postData(
        Controller,
        SchmEndPoint.ValidationProductData,
        payloadprod
      );
      if (validationProdRes?.Message === "Warning") {
        toast.warn("There are errors in file upload.");
        setErrorxlsProdData(validationProdRes.Data);
        setShowErrorbtnprod(true);
      } else {
        toast.success("Data uploaded succesfully");
        setUploadedProd(validationProdRes.Data);
      }
    } catch (e: any) {
      toast.error(`${e.response.data.Message}`);
    } finally {
      clearTimeout(timer);
      setTempprodUpLoading(false);
      setShowUpprodloading(false);
    }
  };

  const excelErrorDownload = () => {
    downloadExcelDateFormat(
      errorxlsData,
      `Error_${schmUploadType?.Name}_Validate_${GetDateFormat()}.xlsx`
    );
  };
  const excelErrorprodDownload = () => {
    downloadExcelDateFormat(
      errorxlsProdData,
      `Error_Product_Validate_${GetDateFormat()}.xlsx`
    );
  };

  return (
    <main>
      <div className="col-12 mb-5">
        <div className="row">
          {loadingWhl ? <Loader /> : <></>}
          <div className="col-lg-4 col-md-12 col-sm-12">
            {/* <h3 className="py-2">Scheme Discount Definition <span className="text-danger ms-2" onClick={(e) => op?.current?.toggle(e)} style={{ fontSize: "12px" }}>Notes <Fa.FaInfoCircle style={{ marginTop: "-2px" }} /></span></h3> */}
            <h3 className="py-2">Flat Discount Definition</h3>
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12">
            <div className="text-end">
              <Link to="/Master/Scheme/SchemeDiscDefAllRec">
                <button type="button" className="btn anime-secondary-btn">
                  <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                  Records
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className="col-12">
          <section className="sales-box">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Scheme Code</label>
                  <InputText
                    placeholder="Enter scheme code"
                    value={schemeCode}
                    disabled={viewSchmDetls}
                    onChange={(e) => {
                      setSchemeCode(e.target.value.toUpperCase());
                      setErrors({ ...errors, schemeCode: null });
                    }}
                    className={
                      submitted && errors.schemeCode
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                  />
                  {submitted && errors.schemeCode && (
                    <small className="p-error">{errors.schemeCode}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Scheme Name</label>
                  <InputText
                    placeholder="Enter scheme name"
                    value={schemeName}
                    disabled={viewSchmDetls}
                    onChange={(e) => {
                      setSchemeName(e.target.value);
                      setErrors({ ...errors, schemeName: null });
                    }}
                    className={
                      submitted && errors.schemeName
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                  />
                  {submitted && errors.schemeName && (
                    <small className="p-error">{errors.schemeName}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Start Date</label>
                  <Calendar
                    value={schmstartdt}
                    placeholder="Select start date"
                    disabled={viewSchmDetls}
                    onChange={(e) => {
                      setSchmstartdt(e.value as Date);
                      setErrors({ ...errors, schmstartdt: null });
                    }}
                    dateFormat="dd/mm/yy"
                    minDate={tomorrow}
                    showMinMaxRange
                    showIcon
                    className={
                      submitted && errors.schmstartdt
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                  />
                  {submitted && errors.schmstartdt && (
                    <small className="p-error">{errors.schmstartdt}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">End Date</label>
                  <Calendar
                    value={schmenddt}
                    placeholder="Select end date"
                    onChange={(e) => {
                      setSchmenddt(e.value as Date);
                      setErrors({ ...errors, schmenddt: null });
                    }}
                    dateFormat="dd/mm/yy"
                    minDate={viewSchmDetls ? schmstartdt : tomorrow}
                    showMinMaxRange
                    className={
                      submitted && errors.schmenddt
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                    showIcon
                    disabled={
                      isEndDateToday || selectedSchm[0]?.IS_ACTIVE == "Inactive"
                    }
                  />
                  {submitted && errors.schmenddt && (
                    <small className="p-error">{errors.schmenddt}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Discount Type</label>
                  <Dropdown
                    value={discountType}
                    onChange={(e) => setDiscountType(e.value)}
                    options={discountTypeopt}
                    optionLabel="name"
                    disabled
                    placeholder="Select discount type"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Percentage</label>
                  <InputNumber
                    className={
                      submitted && errors.percentagevalue
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                    value={percentagevalue}
                    onValueChange={(e) => {
                      setPercentagevalue(e.value);
                      setErrors({ ...errors, percentagevalue: null });
                    }}
                    maxFractionDigits={2}
                    // minFractionDigits={2}
                    suffix=" %"
                    max={100}
                    min={0}
                    required
                    disabled={viewSchmDetls}
                    placeholder="Select percentage"
                  />
                  {submitted && errors.percentagevalue && (
                    <small className="p-error">{errors.percentagevalue}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block">
                  <label className="form-label">
                    Total invoice value (pre-GST)
                  </label>
                  <InputNumber
                    className={
                      submitted && errors.invAmount
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                    value={invAmount}
                    onValueChange={(e) => {
                      setInvAmount(e.value);
                      setErrors({ ...errors, invAmount: null });
                    }}
                    maxFractionDigits={2}
                    // minFractionDigits={2}
                    min={0}
                    prefix="₹ "
                    required
                    disabled={viewSchmDetls}
                    placeholder="Enter invoice value"
                  />
                  {submitted && errors.invAmount && (
                    <small className="p-error">{errors.invAmount}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label d-block mb-2">
                    Include Promo Code
                  </label>
                  <div className="flex align-items-center">
                    <Checkbox
                      inputId="promoIncluded"
                      checked={promocodeStats}
                      disabled={viewSchmDetls}
                      onChange={(e: any) => {
                        setPromocodeStats(e.checked);
                        setTargetProd([]);
                        setUploadedProd([]);
                        populateProduct(e.checked);
                        setShowErrorbtnprod(false);
                        if (prodfileInputRef.current) {
                          prodfileInputRef.current.value = "";
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                <div className="d-block mb-2">
                  <label className="form-label d-block mb-2">
                    Activation Status
                  </label>
                  <div className="d-inline-flex">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="Activation1"
                        name="Activation"
                        value="Active"
                        onChange={(e) => setActivationsts(e.value)}
                        checked={activationsts === "Active"}
                        disabled={selectedSchm[0]?.IS_ACTIVE == "Inactive"}
                      />
                      <label
                        htmlFor="Activation1"
                        className="form-label ms-2 mb-0"
                      >
                        Active
                      </label>
                    </div>
                    <div className="flex align-items-center ms-3">
                      <RadioButton
                        inputId="Activation2"
                        name="Activation"
                        value="Inactive"
                        onChange={(e) => setActivationsts(e.value)}
                        checked={activationsts === "Inactive"}
                        disabled={selectedSchm[0]?.IS_ACTIVE == "Inactive"}
                      />
                      <label
                        htmlFor="Activation2"
                        className="form-label ms-2 mb-0"
                      >
                        Inactive
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                <div className="d-block mb-2">
                  <label className="form-label d-block mb-2">
                    Scheme Benefit
                  </label>
                  <div className="d-inline-flex">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="Scheme1"
                        name="Include"
                        value="Include"
                        onChange={(e) => setSchmbenefitstats(e.value)}
                        checked={schmbenefitstats === "Include"}
                        disabled={viewSchmDetls}
                      />
                      <label htmlFor="Scheme1" className="form-label ms-2 mb-0">
                        Include
                      </label>
                    </div>
                    <div className="flex align-items-center ms-3">
                      <RadioButton
                        inputId="Scheme2"
                        name="Exclude"
                        value="Exclude"
                        disabled={viewSchmDetls}
                        onChange={(e) => setSchmbenefitstats(e.value)}
                        checked={schmbenefitstats === "Exclude"}
                      />
                      <label htmlFor="Scheme2" className="form-label ms-2 mb-0">
                        Exclude
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                <div className="d-block mb-2">
                  <label className="form-label d-block mb-2">
                    Product Applicability
                  </label>
                  <div className="d-inline-flex">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="prodAll"
                        name="All"
                        value="All"
                        onChange={(e) => setProbapplic(e.value)}
                        checked={probapplic === "All"}
                        disabled={viewSchmDetls}
                      />
                      <label htmlFor="prodAll" className="form-label ms-2 mb-0">
                        All
                      </label>
                    </div>
                    <div className="flex align-items-center ms-3">
                      <RadioButton
                        inputId="prodAll1"
                        name="Any"
                        value="Any"
                        onChange={(e) => setProbapplic(e.value)}
                        checked={probapplic === "Any"}
                        disabled={viewSchmDetls}
                      />
                      <label
                        htmlFor="prodAll1"
                        className="form-label ms-2 mb-0"
                      >
                        Any
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="sales-box">
            {/* <form> */}
            <div className="row mb-2">
              <div className="col-lg-3 col-md-12 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Upload Type</label>
                  <Dropdown
                    value={schmUploadType}
                    onChange={(e) => {
                      setSchmUploadType(e.value);
                      setSelectedstate([]);
                      setSelectedRegion([]);
                      setSourceDist([]);
                      setTargetDist([]);
                      setStreamType(null);
                      setCustSegType("All");
                      setUploadedCust([]);
                      setUploadedStream([]);
                      setShowErrorbtn(false);
                      setErrors({ ...errors, schmUploadType: null });
                    }}
                    options={schmUploadTypeOption}
                    optionLabel="Name"
                    placeholder="Select a Upload Type"
                    disabled={viewSchmDetls}
                  />
                  {submitted && errors.schmUploadType && (
                    <small className="p-error">{errors.schmUploadType}</small>
                  )}
                </div>
              </div>
            </div>

            {schmUploadType?.Name == "Customer" &&
            (schmCode === "null" || schmCode === "") ? (
              <div className="row d-flex justify-content-end align-items-end">
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <div className="d-block">
                    <label className="form-label">Region</label>
                    <MultiSelect
                      value={selectedRegion}
                      onChange={(e) => {
                        handleRegion(e);
                        setSelectedstate([]);
                        setErrorsDist((prev) => ({ ...prev, region: false }));
                      }}
                      options={region}
                      filter
                      selectAllLabel="Select All"
                      optionLabel="Region_Description"
                      placeholder="Select Region"
                      className={`w-100 ${
                        errorsDist.region ? "p-invalid" : ""
                      }`}
                    />
                    {errorsDist.region && (
                      <small className="text-danger">Region is required</small>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <div className="d-block">
                    <label className="form-label">State</label>
                    <MultiSelect
                      value={selectedstate}
                      onChange={(e) => {
                        setSelectedstate(e.value);
                        setErrorsDist((prev) => ({ ...prev, state: false }));
                      }}
                      filter
                      options={state}
                      selectAllLabel="Select All"
                      optionLabel="State_Name"
                      placeholder="Select State"
                      className={`w-100 ${errorsDist.state ? "p-invalid" : ""}`}
                    />
                    {errorsDist.state && (
                      <small className="text-danger">State is required</small>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="d-block">
                    <label className="form-label">Stream</label>
                    <Dropdown
                      value={streamType}
                      onChange={(e) => {
                        setStreamType(e.value);
                        setErrorsDist((prev) => ({ ...prev, stream: false }));
                        setTargetDist([]);
                        setSourceDist([]);
                        setCustSegType("All");
                      }}
                      options={streamTypeopt}
                      optionLabel="name"
                      placeholder="Select a Stream Type"
                      className={errorsDist.stream ? "p-invalid" : ""}
                    />
                    {errorsDist.stream && (
                      <small className="text-danger">Stream is required</small>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn anime-btn"
                      onClick={populateDistlst}
                    >
                      Get Distributor
                    </button>
                  </div>
                </div>
              </div>
            ) : schmUploadType?.Name == "Segment" &&
              (schmCode === "null" || schmCode === "") ? (
              <>
                <div className="row d-flex justify-content-start align-items-start">
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="d-block">
                      <label className="form-label">Stream</label>
                      <Dropdown
                        value={streamType}
                        onChange={(e) => {
                          setStreamType(e.value);
                          setShowErrorbtn(false);
                          setErrors({ ...errors, streamType: null });
                        }}
                        options={streamTypeopt}
                        optionLabel="name"
                        placeholder="Select a Stream Type"
                      />
                      {submitted && errors.streamType && (
                        <small className="p-error">{errors.streamType}</small>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {schmUploadType?.Name == "Customer" &&
              (schmCode === "null" || schmCode === "") && (
                <div className="border rounded bg-white p-3 my-3">
                  {/* <PickListSchem {}/> */}
                  {distLoading ? (
                    <ProgressSpinner />
                  ) : (
                    <PickListSchem
                      source={sourceDist}
                      target={targetDist}
                      itemTemplatePanel={itemTemplatePanelDist}
                      sourceHeader="Available Distributor"
                      targetHeader="Selected Distributor"
                      filterby="Distributor_Code,Distributor_Name"
                      datakeystr="Distributor_Code"
                      onChange={(newSource, newTarget) => {
                        setSourceDist(newSource);
                        setTargetDist(newTarget);
                      }}
                      mainHeader="Distributor"
                      disabled={false}
                    />
                  )}
                  {/* <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="text-end mt-2">
                      <button
                        type="button"
                        className="btn anime-btn"
                        onClick={allspecificon}
                        disabled={targetDist?.length == 0}
                      >
                        Get Customer by Distributor
                      </button>
                    </div>
                  </div> */}
                </div>
              )}

            {(targetDist.length > 0 || schmUploadType?.Name == "Segment") &&
              (schmCode === "null" || schmCode === "") && (
                <div className="border rounded bg-white p-3 mt-3">
                  <h6 className="text-success mb-3">
                    For {schmUploadType?.Name}
                  </h6>
                  <div className="d-block mb-3">
                    <div className="d-inline-flex">
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="typecustseg1"
                          name="All"
                          value="All"
                          onChange={(e) => setCustSegType(e.value)}
                          checked={custSegType === "All"}
                        />
                        <label
                          htmlFor="typecustseg1"
                          className="form-label ms-2 mb-0"
                        >
                          All
                        </label>
                      </div>
                      <div className="flex align-items-center ms-3">
                        <RadioButton
                          inputId="typecustseg2"
                          name="Specific"
                          value="Specific"
                          onChange={(e) => setCustSegType(e.value)}
                          checked={custSegType === "Specific"}
                        />
                        <label
                          htmlFor="typecustseg2"
                          className="form-label ms-2 mb-0"
                        >
                          Specific
                        </label>
                      </div>
                    </div>
                  </div>

                  {custSegType == "Specific" && (
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-sm-12">
                        <button
                          type="button"
                          className="btn anime-secondary-btn"
                          onClick={downloadTeamplt}
                          disabled={tempLoading}
                        >
                          {tempLoading ? "Loading..." : "Download Template"}{" "}
                          {tempLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <Fa.FaDownload className="ms-2" />
                          )}
                          {/* Download Template <Fa.FaDownload className="ms-2" /> */}
                        </button>
                        <small className="text-danger d-inline-block ms-2">
                          <i>*All available {schmUploadType?.Name}*</i>
                        </small>
                      </div>
                      <div className="col-lg-8 col-md-8 col-sm-12 text-end">
                        <input
                          type="file"
                          accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          id="formFile"
                          ref={fileInputRef}
                          onChange={handleFileUploadXL}
                        />

                        <button
                          type="button"
                          className="btn anime-btn me-3"
                          onClick={handleValidateCustSegXL}
                          disabled={
                            excelData?.length == 0 ||
                            showUploading ||
                            tempUpLoading
                          }
                        >
                          {tempUpLoading
                            ? showUploading
                              ? "Uploading..."
                              : "Validating..."
                            : "Upload File"}
                        </button>
                        {showErrorbtn && (
                          <button
                            type="button"
                            className="btn anime-btn "
                            onClick={excelErrorDownload}
                          >
                            Download Error File
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            {schmCode !== "null" && schmCode !== "" && (
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <button
                    type="button"
                    className="btn anime-secondary-btn"
                    onClick={downloadSavedData}
                    disabled={tempLoading}
                  >
                    {tempLoading ? "Loading..." : "Download"}{" "}
                    {tempLoading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <Fa.FaDownload className="ms-2" />
                    )}
                    {/* Download Template <Fa.FaDownload className="ms-2" /> */}
                  </button>
                  <small className="text-danger d-inline-block ms-2">
                    <i>*Download All Saved {schmUploadType?.Name}*</i>
                  </small>
                </div>
              </div>
            )}
          </section>

          <section className="sales-box">
            <div className="border rounded bg-white p-3">
              <div className="d-inline-flex">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="prodSelrction1"
                    name="Picklist"
                    value="Picklist"
                    onChange={(e) => setProdSelcen(e.value)}
                    checked={prodSelcen === "Picklist"}
                  />
                  <label
                    htmlFor="prodSelrction1"
                    className="form-label ms-2 mb-0"
                  >
                    Select Products
                  </label>
                </div>
                <div className="flex align-items-center ms-3">
                  <RadioButton
                    inputId="prodSelrction2"
                    name="Upload"
                    value="Upload"
                    onChange={(e) => setProdSelcen(e.value)}
                    checked={prodSelcen === "Upload"}
                  />
                  <label
                    htmlFor="prodSelrction2"
                    className="form-label ms-2 mb-0"
                  >
                    Upload All Products
                  </label>
                </div>
              </div>
              <div className="WholePicklistPanel">
                <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                  {prodSelcen === "Picklist" ? (
                    <div className="PickListPanel">
                      <PickListSchem
                        source={sourceProd}
                        target={targetProd}
                        itemTemplatePanel={itemTemplatePanelProd}
                        sourceHeader="Available Products"
                        targetHeader="Selected Products"
                        filterby="Product_ID,Product_Description"
                        datakeystr="Product_ID"
                        onChange={(newSource, newTarget) => {
                          setSourceProd(newSource);
                          setTargetProd(newTarget);
                        }}
                        mainHeader="Products"
                        disabled={schmCode == "null" ? false : true}
                      />
                    </div>
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                          <button
                            type="button"
                            className="btn anime-secondary-btn"
                            onClick={downloadTeampltprod}
                          >
                            Download Template <Fa.FaDownload className="ms-2" />
                          </button>
                          <small className="text-danger d-inline-block ms-2">
                            <i>*All available Product*</i>
                          </small>
                        </div>
                        <div className="col-lg-8 col-md-8 col-sm-12 text-end">
                          <input
                            type="file"
                            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            id="formFile"
                            ref={prodfileInputRef}
                            onChange={handleFileProdup}
                          />

                          <button
                            type="button"
                            className="btn anime-btn me-3"
                            onClick={handleValidateProdXL}
                            disabled={
                              errorxlsProdData?.length == 0 ||
                              showUpprodloading ||
                              tempprodUpLoading
                            }
                          >
                            {tempprodUpLoading
                              ? showUpprodloading
                                ? "Uploading..."
                                : "Validating..."
                              : "Upload File"}
                          </button>
                          {showErrorbtnprod && (
                            <button
                              type="button"
                              className="btn anime-btn "
                              onClick={excelErrorprodDownload}
                            >
                              Download Error File
                            </button>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="col-12">
          <div className="text-end">
            <button
              type="button"
              className="btn anime-btn"
              onClick={submitSchmDisc}
              disabled={saveBtndisle || finalSaveLoading}
            >
              {tempLoading ? "Loading..." : viewSchmDetls ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SchemeDiscountDefinition;
